export enum GroupDetailEnergyScore {
  EnergyScore_0 = 'EnergyScore_0',
  EnergyScore_1 = 'EnergyScore_1',
  EnergyScore_2 = 'EnergyScore_2',
  EnergyScore_3 = 'EnergyScore_3',
  EnergyScore_4 = 'EnergyScore_4',
  EnergyScore_5 = 'EnergyScore_5',
  EnergyScore_6 = 'EnergyScore_6',
  EnergyScore_7 = 'EnergyScore_7',
  EnergyScore_8 = 'EnergyScore_8',
  EnergyScore_9 = 'EnergyScore_9',
  EnergyScore_10 = 'EnergyScore_10'
}
